import { SELECT_COLOR } from '../actions/actionTypes'
import { selectColor } from '../actions/index';

const selectedColor = (state = {}, action) => {
	switch(action.type){
		case SELECT_COLOR:
			return action.id
		default:
			return state;
	}
}

export default selectedColor;


// WEBPACK FOOTER //
// ./src/reducers/selectedColor.js